// extracted by css-extract-rspack-plugin
export default {"charCount":"charCount-r6p6KG text-xs","notify":"notify-DZhhW9","notifyOption":"notifyOption-eOGHmt","notifyName":"notifyName-W_D8Ae text-sm"};